import { Pill } from '#app/ui/components/custom/pill'
import { H2 } from '#app/ui/components/typography/h2'
import { P } from '#app/ui/components/typography/p'
import { cn } from '#app/utils/tailwind-merge.ts'

type SectionHeaderProps = {
	eyebrow: string
	heading: React.ReactNode
	lead?: React.ReactNode
	align?: 'left' | 'center'
	className?: string
}

/**
 * The section header pattern: eyebrow pill, heading, and an optional lead
 * paragraph on a narrow measure.
 */
export const SectionHeader = ({
	eyebrow,
	heading,
	lead,
	align = 'left',
	className,
}: SectionHeaderProps) => {
	const centered = align === 'center'
	return (
		<div
			className={cn(
				'flex flex-col',
				centered ? 'items-center text-center' : 'items-start text-left',
				className,
			)}
		>
			<Pill>{eyebrow}</Pill>
			<H2
				className={cn(
					'mt-fluid-10 max-w-2xl text-balance normal-case',
					centered && 'mx-auto',
				)}
			>
				{heading}
			</H2>
			{lead ? (
				<P
					className={cn(
						'mt-fluid-9 max-w-xl text-muted-600',
						centered && 'mx-auto',
					)}
				>
					{lead}
				</P>
			) : null}
		</div>
	)
}
